import React from 'react';
import PetPhoto from './PetPhoto';
import type { Pet } from '../types';
import '../styles/PetCard.css';

interface PetCardProps {
  pet: Pet;
}

const PetCard: React.FC<PetCardProps> = ({ pet }) => (
  <article className="card">
    <div className="card__portrait">
      <PetPhoto pet={pet} />
      {pet.tag && <span className="card__tag">{pet.tag}</span>}
    </div>
    <h4 className="card__name">{pet.name}</h4>
    <div className="card__facts">{pet.facts}</div>
    <p className="card__copy">{pet.description}</p>
    <a className="card__cta" href={pet.slug ? `/adotar/${pet.slug}` : '#'}>
      ficha {pet.ref} →
    </a>
  </article>
);

export default PetCard;
